// extracted by mini-css-extract-plugin
module.exports = {"infoBlock":"info-block-09e","infoBlockHeader":"info-block__header-c2e","infoBlockBordered":"info-block_bordered-236"};